import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLoginInfo } from '../actions/auth';
import { SSO_RETURN_PATH_KEY } from '../util/appSignIn';

class LoginMicrosoft extends Component {
  constructor() {
    super();
    this.state = {
      finishedLoad: false,
    };
  }

  componentDidMount() {
    this.getInfo();
  }

  getInfo = async () => {
    const { getLoginInfo: getUserInfo } = this.props;
    await getUserInfo();
    this.setState({ finishedLoad: true });
  }

  render() {
    const { finishedLoad } = this.state;

    if (finishedLoad) {
      const path = sessionStorage.getItem(SSO_RETURN_PATH_KEY);
      sessionStorage.removeItem(SSO_RETURN_PATH_KEY);
      return (<Redirect to={path === 'null' ? '/app' : path} />);
    }

    return null;
  }
}

LoginMicrosoft.propTypes = {
  location: PropTypes.object.isRequired,
  getLoginInfo: PropTypes.func.isRequired,
}

export default connect(null, { getLoginInfo })(LoginMicrosoft);

export {
  LoginMicrosoft,
};
